import { render, staticRenderFns } from "./boxHeader.vue?vue&type=template&id=0237d003&scoped=true"
import script from "./boxHeader.ts?vue&type=script&lang=ts&external"
export * from "./boxHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./boxHeader.vue?vue&type=style&index=0&id=0237d003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237d003",
  null
  
)

export default component.exports